const users = [
  {
    id: 1,
    username: "capitan",
    password: "barco123",
    role: "user",
    email: "capitan@example.com",
    loginCount: 5, // Added login count
    boats: [
      {
        id: 1,
        name: "Velero María",
        viewCount: 10, // Added view count for boat
        scans: [
          {
            id: 1,
            date: "2023-05-15",
            embedCode: "<iframe src='https://sketchfab.com/models/a3111111111111111111111111111111/embed?autostart=1&amp;preload=1&amp;transparent=1&amp;ui_ar=0&amp;ui_infos=0&amp;ui_snapshots=1&amp;ui_stop=0&amp;ui_theme=light&amp;ui_watermark=0' frameborder='0' allow='autoplay; fullscreen; vr' mozallowfullscreen='true' webkitallowfullscreen='true'></iframe>",
            documents: [
              {
                id: 1,
                name: "Planos DWG",
                type: "dwg",
                url: "https://docs.google.com/viewer?url=https://file-examples-com.github.io/uploads/2017/02/file-example-DWG-1MB.dwg&embedded=true"
              },
              {
                id: 2,
                name: "Especificaciones PDF",
                type: "pdf",
                url: "https://docs.google.com/viewer?url=https://file-examples-com.github.io/uploads/2017/10/file-example-PDF-1MB.pdf&embedded=true"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: 2,
    username: "admin",
    password: "admin123",
    role: "admin",
    email: "admin@example.com",
    loginCount: 15, // Added login count
    boats: []
  },
  {
    id: 3,
    username: "masteradmin1",
    password: "master123",
    role: "masteradmin",
    email: "masteradmin1@example.com",
    loginCount: 20, // Added login count
    boats: []
  },
   {
    id: 4,
    username: "masteradmin2",
    password: "master123",
    role: "masteradmin",
    email: "masteradmin2@example.com",
    loginCount: 18, // Added login count
    boats: []
  },
  {
    id: 5,
    username: "invitado",
    password: "invitado123",
    role: "guest",
    email: "invitado@example.com",
    loginCount: 8, // Added login count
    boats: []
  },
  {
    id: 6,
    username: "grumete",
    password: "grumete123",
    role: "user",
    email: "grumete@example.com",
    loginCount: 12, // Added login count
    boats: [
      {
        id: 2,
        name: "La Pinta",
        viewCount: 25, // Added view count for boat
        scans: [
           {
            id: 2,
            date: "2024-01-20",
            embedCode: "<iframe src='https://sketchfab.com/models/b4222222222222222222222222222222/embed?autostart=1&amp;preload=1&amp;transparent=1&amp;ui_ar=0&amp;ui_infos=0&amp;ui_snapshots=1&amp;ui_stop=0&amp;ui_theme=light&amp;ui_watermark=0' frameborder='0' allow='autoplay; fullscreen; vr' mozallowfullscreen='true' webkitallowfullscreen='true'></iframe>",
            documents: [
              {
                id: 3,
                name: "Manual de Navegación",
                type: "pdf",
                url: "https://docs.google.com/viewer?url=https://file-examples-com.github.io/uploads/2017/10/file-example-PDF-1MB.pdf&embedded=true"
              }
            ]
          }
        ]
      }
    ]
  }
];

export default users;